const plotValidations = {
  reason: 'optional nonEmpty length160',
  chosenEmotionWord: 'nonEmpty',
}

export default plotValidations
